import { connect } from 'react-redux';

import { openEvent, rescheduleEvent } from '../../../../redux/calendar';
import { toggleDeleteModal, toggleDeliveryModal } from '../../../../redux/modals';
import DeliveryEvent from './DeliveryEvent';

const makeGetEvent = () => (state, { eventId }) => state.events.events.find((e) => e.id === eventId);

const makeMapStateToProps = () => {
  const getEvent = makeGetEvent();
  return (state, props) => ({
    detailEnabled: state.settings.detailEnabled,
    entity: state.settings.entity,
    event: getEvent(state, props),
    financialEnabled: state.settings.financialEnabled,
    hasCalendarEventDelete: state.tokenInfo.scope.indexOf('calendarEvents:delete') > -1,
    hasCalendarEventUpdate: state.tokenInfo.scope.indexOf('calendarEvents:update') > -1,
    locationEnabled: state.settings.locationEnabled,
    materialEnabled: state.settings.materialEnabled
  });
};

const mapDispatchToProps = (dispatch, { eventId }) => ({
  onClick: () => dispatch(rescheduleEvent(eventId)),
  onDeleteEventClick: () => dispatch(toggleDeleteModal(eventId)),
  onEditEventClick: () => dispatch(toggleDeliveryModal(eventId)),
  onOpenClick: () => dispatch(openEvent(eventId))
});

const mergeProps = ({ hasCalendarEventDelete, hasCalendarEventUpdate, ...stateProps }, { onClick, onDeleteEventClick, onEditEventClick, ...dispatchProps }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onClick: hasCalendarEventUpdate ? onClick : null,
  onDeleteEventClick: hasCalendarEventDelete ? onDeleteEventClick : null,
  onEditEventClick: hasCalendarEventUpdate ? onEditEventClick : null
});

export default connect(makeMapStateToProps, mapDispatchToProps, mergeProps)(DeliveryEvent);
